/**
 * `data-pl-copy="..."` / `data-pl-copy-from="#sel"` — копирование в буфер.
 *
 * При клике текст в буфере, кнопка на 2с показывает success-text
 * (default «Скопировано», переопределяется через `data-pl-copy-success`).
 */

const INIT_FLAG = 'plCopyInitialized';

async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* fallthrough */
    }
  }
  // Fallback для контекстов без Clipboard API (insecure / iframe).
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}

function resolveText(el: HTMLElement): string {
  const direct = el.getAttribute('data-pl-copy');
  if (direct !== null) return direct;
  const from = el.getAttribute('data-pl-copy-from');
  if (from) {
    const node = document.querySelector(from);
    if (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement) {
      return node.value;
    }
    if (node) return node.textContent ?? '';
  }
  return '';
}

function attach(el: HTMLElement): void {
  if (el.dataset[INIT_FLAG]) return;
  el.dataset[INIT_FLAG] = '1';
  el.addEventListener('click', async (e) => {
    e.preventDefault();
    const text = resolveText(el);
    const success = await copyText(text);
    if (!success) return;
    const original = el.textContent;
    const successText = el.getAttribute('data-pl-copy-success') ?? t('copy.success');
    el.textContent = successText;
    window.setTimeout(() => {
      if (el.dataset[INIT_FLAG]) el.textContent = original;
    }, 2000);
  });
}

export function initCopy(nodes: NodeListOf<Element> | Element[]): void {
  for (const node of Array.from(nodes)) {
    if (node instanceof HTMLElement) attach(node);
  }
}
import { t } from '../i18n/index.js';
